import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ma-whatsapp-link',
  templateUrl: './whatsapp-link.component.html',
  styleUrls: ['./whatsapp-link.component.scss']
})
export class WhatsappLinkComponent implements OnInit {

  constructor(
  ) {
  }

  ngOnInit(): void {

  }

}
